import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import ScrollToTop from 'react-scroll-to-top';
import { PropertyCard } from './PropertyCard';
import { Home } from 'react-feather';

export const MyDraftListings = () => {
  const queryClient = useQueryClient();
  const [search, setSearch] = useState('');
  const [userId] = useState(localStorage.getItem('userId'));
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [propertyID, setPropertyID] = useState('');
  const [propertyRef, setPropertyRef] = useState(null);
  const [properties, setProperties] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [userID] = useState(localStorage.getItem('userId'));
  const navigate = useNavigate();


  useEffect(() => {
    document.title = 'Favourites';
    window.scrollTo(0, 0);
  }, []);

  const fetchDraftListings = () => {
    const options = {
      method: 'GET',
      url: `/Property/GetDraftProperties/${localStorage.getItem('staffMemberId')}/false`,
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const {
    isLoading,
    isError,
    error,
    data: favouritesData,
  } = useQuery(['Drafts'], fetchDraftListings);


  const filterFavouriteData = (favouritesDatafilter, search) => {
    if (!search) {
      return favouritesDatafilter;
    }

    return favouritesDatafilter.filter((data) => {
      return (
        data?.propertyTypeName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        data?.localityName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        data?.propertyStateName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        data?.propertyRef.includes(search)
      );
    });
  };

  const filterFavouriteDatas = filterFavouriteData(
    favouritesData,
    search,
  );

  if (isLoading) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <Loader
            type="TailSpin"
            color="black"
            height="50"
            width="50"
          />
        </div>
      </div>
    );
  }

  if (isError || error) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="container vh-100">
      <ScrollToTop smooth color="#6f00ff" />
      <div className='row'>
        <div className="col-9 col-xl-9 col-xl-9 ml-0 p-0">
          <div className="h4 mb-3 ml-0 font-weight-bold">
            <Home />&nbsp;
            My Draft Listings
          </div>
          <div className="h6 mb-3 ml-0">
            You have{' '}
            {filterFavouriteDatas?.length > 1
              ? `${filterFavouriteDatas?.length} draft properties`
              : `${filterFavouriteDatas?.length} draft property`}{' '}
          </div>
        </div>
        <div className="col-3 col-md-3 col-xl-3 text-right">
          <p className="btn btn-danger d-block" onClick={() => navigate(-1)}>
            Back
          </p>
        </div>
      </div>
      <div className="row">
        <div className="form-group has-search w-100">
          <span className="fa fa-search form-control-feedback"></span>
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        {filterFavouriteDatas?.length < 1 ? (
          <h4 className="mx-auto">No search results found</h4>
        ) : null}
        <div className="container pl-0 pr-0">
          <div className="row mb-4">
            {filterFavouriteDatas &&
              React.Children.toArray(
                filterFavouriteDatas?.map((property, index) => (
                  <PropertyCard
                    property={property}
                    index={index}
                    location={location}
                    showRemoveFavouriteBtn={false}
                    showHotBtn={false}
                   />
                )),
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
